import { AuthenticateApi, BankIdApi, BannersApi, CallCenterApi, ChangeRequestsApi, ConsentApi, ContactsApi, ContractsApi, ContractsDpsApi, ContractsLifeApi, ContractsPpApi, DocumentsApi, InvestorProfileApi, PostLoginApi, ProfileApi, RegistrationApi } from "./apis";
import { DevelopmentDataConfig } from "./models/DevelopmentDataConfig";
import { ErrorResponse } from "./models/ErrorResponse";
import { ConfigurationParameters, HTTPHeaders } from "./runtime";

export interface IContextPrimaryAPIClient {
    callCenterApi: CallCenterApi;
    profileApi: ProfileApi;
    changeRequestsApi: ChangeRequestsApi;
    consentApi: ConsentApi;
    contactsApi: ContactsApi;
    contractsApi: ContractsApi;
    documentsApi: DocumentsApi;
    investorProfileApi: InvestorProfileApi;
    configurationParameters: ConfigurationParameters;
    contractsDpsApi: ContractsDpsApi;
    contractsLifeApi: ContractsLifeApi;
    contractsPpApi: ContractsPpApi;
    authenticateApi: AuthenticateApi;
    postLoginApi: PostLoginApi;
    registrationApi: RegistrationApi;
    bannersApi: BannersApi;
    bankIdApi: BankIdApi;
}

export class FetchApiError<T extends {} = ErrorResponse> extends Error {
    constructor(public errorResponse: T, message?: string) {
        super(message);
    }
}

export const parseError = async (
    response: Response
): Promise<ErrorResponse> => {
    try {
        return (await response.json()) as ErrorResponse;
    } catch {
        return {
            code: response.status,
            message: "Uknown error response without body.",
        };
    }
};

export const getHeaders = (
    config: DevelopmentDataConfig | undefined
): HTTPHeaders | undefined => {
    if (!config) return undefined;
    return {
        "X-DEV-DATA-CONFIG": JSON.stringify(config),
    };
};


export const assertSuccessStatusCode = async (response: Response) => {
    if (!response.ok) {
        throw new FetchApiError(await parseError(response));
    }
};